<template>
  <div>
    <div class="wrapper">
      <div class="container">
        <div class="breadcrumb-list">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">Company Profile</li>
          </ol>
        </div>
        <div class="page-holder">
          <div class="main-box personal-info-page bg-transparent">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-sm-12 info-card-holder">
                <div class="info-card">
                  <div class="info-head d-flex">
                    <div class="align flex-grow-1">
                      <!-- <h5>Name</h5>
                      <span class="text-capitalize">{{ form.name }}</span> -->
                      <!-- :src="$API_URL+'storage/'+employeeData.image" -->
                      <img :src="$API_URL+'storage/'+ this.$store.getters.getSelectedCompany.logo"  width="160" height="50"  alt="Logo" v-if="this.$store.getters.getSelectedCompany.logo">
                      <span v-else>
                        {{ this.$store.getters.getSelectedCompany.name }}
                      </span>
                      <!-- <img :src="require('@/assets/images/CleverStaff_head_logo.svg')"  width="160"  alt="Logo"> -->
                    </div>
                    <router-link
                      to="/my-companies"
                      class="edit-icon flex-shrink-0 pl-2"
                    >
                      Manage Other Companies
                    </router-link>
                  </div>
                  <div class="info-card-body">
                    <div class="info-card-holder">
                      <div class="emp-info">
                        <span class="label-text">First Name</span>
                        <span class="emp-data">{{
                          this.$store.getters.getUser.name.split(" ")[0]
                        }}</span>
                      </div>
                      <div class="emp-info">
                        <span class="label-text">Last Name</span>
                        <span class="emp-data">{{
                          this.$store.getters.getUser.name.split(" ")[1]
                        }}</span>
                      </div>
                    </div>
                    <div class="info-card-holder">
                      <div class="emp-info">
                        <span class="label-text">Phone</span>
                        <span class="emp-data">{{ form.phone }}</span>
                      </div>
                      <div class="emp-info">
                        <span class="label-text">Company Registration Number</span>
                        <span class="emp-data">{{ form.cvr }}</span>
                      </div>
                    </div>
                    <div class="info-card-holder">
                      <div class="emp-info">
                        <span class="label-text">E-mail</span>
                        <span class="emp-data">{{ form.email }}</span>
                      </div>
                      <div class="emp-info">
                        <span class="label-text">POSTCODE</span>
                        <span class="emp-data">{{ form.postcode }}</span>
                      </div>
                    </div>
                    <div class="info-card-holder">
                      <div class="emp-info">
                        <span class="label-text">Country</span>
                        <span class="emp-data">{{ form.country }}</span>
                      </div>
                      <div class="emp-info">
                        <span class="label-text">Currency</span>
                        <span class="emp-data">{{ currencyName }}</span>
                      </div>
                    </div>

                    <address class="emp-address">
                      <span class="label-text">Address</span>
                      <span class="emp-data">{{ form.address }}</span>
                    </address>

                    <div class="float-right">
                      <button
                        class="btn btn-outline-primary"
                        data-toggle="modal"
                        data-target="#profile-employee"
                      >
                        Edit
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-sm-12 info-card-holder">
                <div class="info-card">
                  <div class="info-head d-flex">
                    <div class="align flex-grow-1">
                      <h5>Company Job Roles</h5>
                    </div>
                    <create-employee-btn :labelBtn="labelCreateNewEmpBtn" :uniqueKey="uniqueKey"></create-employee-btn>
                    <!--
                    <a
                      href="javascript:void(0)"
                      id="create-employee"
                      class="edit-icon flex-shrink-0 pl-2 float-right"
                      data-toggle="modal"
                      data-target="#creat-employee"
                      @click="refreshJobRoles"
                      >Create New Employee</a
                    >-->
                  </div>
                  <div class="info-card-body">
                    <div class="info-card-holder">
                      <div class="emp-info">
                        <span class="label-text">Add job Role(s)</span>
                        <multiselect
                          v-model="getlist"
                          tag-placeholder="Add this as new tag"
                          placeholder="Search or add a tag"
                          label="name"
                          track-by="name"
                          :options="options"
                          :multiple="true"
                          :taggable="true"
                          @tag="addTag"
                          :max-height="200"
                          @select="onSelect"
                          @remove="deleteTag"
                        >
                        </multiselect>
                        <!-- <pre ><code>{{ value  }}</code></pre> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 m-bottom">
                <div class="employment-details">
                  <div class="info-head">
                    <h5>
                      Company Benefits
                      <button
                        class="btn btn-outline-primary"
                        data-toggle="modal"
                        @click="clearNameAmount"
                        data-target="#add-company-benefit"
                      >
                        Add Company Benefit
                      </button>
                    </h5>
                  </div>

                  <div class="col-xl-8 col-md-12">
                    <div class="table-scroll employee-benifits">
                      <table class="table">
                        <thead class="table-head">
                          <tr>
                            <th scope="col">Description</th>
                            <th scope="col">AMOUNT</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(benefit, index) of companyBenefits"
                            :key="index"
                            v-show="showHide2"
                          >
                            <td class="text-capitalize">
                         <!-- <div
                                class="form-control"
                                :id="'benefit-name-' + benefit.id"
                              >
                                {{ benefit.name }}
                              </div>-->
                             <span v-if="benefit.benefitCategory">{{benefit.benefitCategory.name}}</span>
                             <span v-else> {{ benefit.name }}</span>
                            </td>
                            <td>
                              <div
                                class="form-control"
                                :id="'benefit-amount-' + benefit.id"
                              >
                                {{ currencyFormatter2(benefit.amount) }}
                              </div>
                            </td>
                            <td>
                              <a
                                href="javascript:void(0)"
                                class="edit-icon flex-shrink-0 pl-2"
                                data-toggle="modal"
                                data-target="#benefit-modal"
                                @click="openBenefitModal(benefit.id)"
                                ><i class="ico-pencil"></i
                              ></a>
                              &nbsp;&nbsp;&nbsp;<a
                                href="javascript:void(0)"
                                @click="deleteCompanyBenefit(benefit.id)"
                                ><i class="ico ico-delete"></i
                              ></a>
                            </td>
                          </tr>

                          <tr
                            v-for="benefit of companyBenefits2"
                            :key="benefit.id"
                            v-show="showHide"
                          >
                            <td>
                              <div
                                class="form-control"
                                :id="'benefit-name-' + benefit.id"
                              >
                                {{ benefit.name }}
                              </div>
                            </td>
                            <td>
                              <div
                                class="form-control"
                                :id="'benefit-amount-' + benefit.id"
                              >
                                {{ currencyFormatter2(benefit.amount) }}
                              </div>
                            </td>
                            <td>
                              <a
                                href="javascript:void(0)"
                                class="edit-icon flex-shrink-0 pl-2"
                                data-toggle="modal"
                                data-target="#benefit-modal"
                                @click="openBenefitModal(benefit.id)"
                                ><i class="ico-pencil"></i
                              ></a>
                              &nbsp;&nbsp;&nbsp;<a
                                href="javascript:void(0)"
                                @click="deleteCompanyBenefit(benefit.id)"
                                ><i class="ico ico-delete"></i
                              ></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- add new benefit modal -->
    <div
      class="modal fade write-msg-model creat-employee-modal"
      id="add-company-benefit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="write-msg-modelLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5>Company Benefit</h5>
            </div>
            <button
              type="button"
              class="close"
              ref="closeModal"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="scrolling">
              <div class="inputs-wrapper">
                <div class="inputs-holder">
                  <div class="field-col">

                    <label>Benefit Name:</label>
                    <span class="text-danger">*</span>
<!--                    <input
                      type="text"
                      class="form-control"
                      v-model="benefitName"
                    />
                    <p class="textRed" v-show="benefitNam">Name is required</p>-->
                    <select name="" id="" class="form-control text-capitalize" v-model="benefitCategoryId">
                      <option value=""> Select</option>
                      <option value="" v-for="benefitCategory in benefitCategories" :value="benefitCategory.id" class="text-capitalize"> {{ benefitCategory.name }}</option>
                    </select>
                  </div>
                  <div class="field-col">
                    <label>Benefit Amount:</label>
                    <span class="text-danger">*</span>
                    <input
                      type="text"
                      class="form-control"
                      v-model="BenefitAmount"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      maxlength = "7"
                      placeholder=""
                    />
                    <p class="textRed" v-show="benefitamn">Amount is required</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0)"
              class="btn btn-outline-warning btn-sm f-bold"
              data-dismiss="modal"
              >Cancel</a
            >
            <button
              type="button"
              class="btn btn-outline-primary btn-sm f-bold"
              @click="SaveCompanyBenefit"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- benefit edit modal -->
    <div
      class="modal fade write-msg-model creat-employee-modal"
      id="benefit-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="write-msg-modelLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5>Update Company Benefit</h5>
            </div>
            <button
              type="button"
              class="close"
              ref="closeModal"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="scrolling">
              <div class="inputs-wrapper">
                <div class="inputs-holder">
                  <div class="field-col">
                    <label>Benefit Name:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="benefitName"
                    />
                  </div>
                  <div class="field-col">
                    <label>Benefit Amount</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="BenefitAmount"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      maxlength = "7"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0)"
              class="btn btn-outline-warning btn-sm f-bold"
              data-dismiss="modal"
              >Cancel</a
            >
            <button
              type="button"
              class="btn btn-outline-primary btn-sm f-bold"
              data-dismiss="modal"
              @click="UpdateBenefit"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--modal-->
    <div
      class="modal fade write-msg-model creat-employee-modal"
      id="profile-employee"
      tabindex="-1"
      role="dialog"
      aria-labelledby="write-msg-modelLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5>Edit Company Detail</h5>
              <p class="gray-text">
                Please make sure that the entered information is correct.
              </p>
            </div>
            <button
              type="button"
              class="close"
              ref="closeModal"
              data-dismiss="modal"
              @click="getCompany"
              aria-label="Close"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="scrolling">
              <div class="inputs-wrapper">
                <div class="inputs-holder">
                  <div class="field-col">
                    <label>Company Name:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.name"
                    />
                  </div>
                  <div class="field-col">
                    <label>CVR</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.cvr"
                      placeholder=""
                    />
                  </div>
                  <div class="field-col">
                    <label>E-Mail</label>
                    <input
                      type="email"
                      class="form-control"
                      v-model="form.email"
                      @keyup="validate($event,'email')"
                    />
                    <p v-if="validity.email === 'invalid'" :class="{textRed : validity.email === 'invalid'}">Enter valid email</p>
                  </div>
                </div>

                <div class="inputs-holder">
                  <div class="field-col">
                    <label>Post Code:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.postcode"
                      placeholder=""
                    />
                  </div>
                  <div class="field-col">
                    <label>Address:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.address"
                      placeholder=""
                    />
                  </div>
                  <div class="field-col">
                    <label>Country:</label>
                    <select
                      class="form-control form-control-lg countryWithCurrency"
                      v-model="form.country"
                      @change="selectCurrency"
                    >
                      <option
                        v-for="(country, index) of countries"
                        :key="index"
                        :id_attr="country.id"
                      >
                        {{ country.country }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="inputs-holder">
                  <div class="field-col">
                    <label>Currency:</label>
                    <select
                      class="form-control form-control-lg"
                      v-model="form.currency_id"
                    >
                      <option
                        v-for="(currency, index) of currencies"
                        :key="index"
                        :value="currency.id"
                      >
                        {{ currency.code }}
                      </option>
                    </select>
                  </div>
                  <div class="field-col">
                    <label>Company Logo:</label>
                    <input
                      type="file"
                      class="form-control"
                      ref="companylogo"
                      @change="saveCompanyLogo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-warning btn-sm f-bold"
              data-dismiss="modal"
              @click="getCompany"
              >Cancel</button>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm f-bold"
              data-dismiss="modal"
              :disabled="saveBtn"
              @click.prevent="Update"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect          from "vue-multiselect";

import createEmployeeBtn  from "../Employees/createEmployeeBtn";
import Swal from "sweetalert2";
export default {
  name: "companyProfile",
  components: {
    Multiselect,

    createEmployeeBtn,
  },
  data() {
    return {
      labelCreateNewEmpBtn         : 'Create New Employee',
      uniqueKey         : 0,
      showHide          : false,
      showHide2         : true,
      benefitName       : "",
      benefitCategoryId       : "",
      BenefitAmount     : 0,
      benefitId         : 0,
      company_id        : this.$store.getters.getSelectedCompany.id,
      companyBenefits   : this.$store.getters.getSelectedCompany.companyBenefits,
      companyBenefits2  : [],
      companyLogo       : "",
      form              : {
        requestFrom        : 'web',
        name        : null,
        cvr         : null,
        address     : null,
        postcode    : null,
        industry_id : 1,
        company_id  : this.$store.getters.getSelectedCompany.id,
        latitude    : "31.5204",
        longitude   : "74.3587",
        jobRoles    : [],
        country     : "",
        currency_id : "",
        email       :''
      },
      options         : [],
      rolesList       : [],
      value           : [],
      getlist         : [],
      getlist2        : [],
      id              : null,
      companyid       : null,
      allJobroles     : [],
      unique          : [],
      jobRoleUniq     : [],
      jobRequired     : "",
      countries       : [],
      currencies      : [],
      counter         : 0,
      currencyName    : "",
      validity        :{
        email     :'',
      },
      saveBtn         :false,
      benefitamn: false,
      benefitCategories: [],

      benefitNam : false
    };
  },
  watch: {
    getlist(v) {
     // console.log("input", v);
    },
  },
  created() {

    this.getJobRolesList();
    this.getBenefitCategories();
   // console.log(this.$store.getters.getSelectedCompany,'company==');

  },
  beforeMount() {},
  mounted() {
    var currencyObj = {
      code: "PKR",
    };
    this.currencyName =
      this.$store.getters.getSelectedCompany.currency !== null
        ? this.$store.getters.getSelectedCompany.currency.code
        : currencyObj.code;
    this.getJobRolesList();
    this.getCompany();
    this.getCountries();
    this.$root.$emit("activeCompoClick");
  },
  methods: {
    getBenefitCategories() {
      this.$axios
        .get(this.$benefitCategories, {
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.benefitCategories = response.data.result || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    currencyFormatter2(value){
     return this.currencyFormatter(value);
    },
    validate(event,fieldname = ''){
      if(fieldname === 'email' || fieldname === ''){
            var re = /\S+@\S+\.\S+/;
            if(this.form.email === '' || !re.test(this.form.email)){
              this.validity.email = 'invalid';
              this.saveBtn = true;
              return false;
            }else{
              this.validity.email = '';
              this.saveBtn = false;
              return true;
            }
        }
    },
    selectCurrency() {
      this.form.currency_id = $(".countryWithCurrency :selected").attr(
        "id_attr"
      );
    },
    getCountries() {
      this.$axios({
        method: "get",
        url: this.$GetCountries,
      }).then((response) => {
        if (response.data.status === 200) {
          this.countries = response.data.result;
          this.currencies = response.data.result;
        }
      });
    },
    deleteCompanyBenefit(id) {
      if (confirm("Are you sure you want to delete this benefit?")) {
        this.$axios({
          method: "POST",
          data: {
            id: id,
            company_id: this.$store.getters.getSelectedCompany.id,
          },
          url: this.$DeleteCompanyBenefit,
          headers: this.getAuthHeader(),
        }).then((res) => {
          if (res.data.status == 200) {
            this.companyBenefits = [];
            this.showHide = false;
            this.showHide2 = true;
            this.$store.commit("setUser", res.data.result);
            this.companyBenefits =
              this.$store.getters.getSelectedCompany.companyBenefits;
            $root.$toast.success(res.data.message);
            $("#add-company-benefit").modal("hide");
          }
        });
      }
    },
    SaveCompanyBenefit() {
      if(this.benefitCategoryId && this.BenefitAmount){
        this.$axios({
          method: "POST",
          data: {
            benefit_category_id: this.benefitCategoryId,
            name: this.benefitName,
            amount: this.BenefitAmount,
            id: this.$store.getters.getSelectedCompany.id,
          },
          url: this.$SaveCompanyBenefit,
          headers: this.getAuthHeader(),
        }).then((res) => {
          if (res.data.status == 200) {
            this.companyBenefits  = [];
            this.showHide         = true;
            this.showHide2        = false;
            this.benefitamn       = false;
            this.benefitNam       = false;
            this.benefitCategoryId       = false;
            this.$store.commit("setUser", res.data.result);
            this.companyBenefits2 =
              this.$store.getters.getSelectedCompany.companyBenefits;
            $root.$toast.success(res.data.message);
            $("#add-company-benefit").modal("hide");
          } else {
            $root.$toast.error(res.data.message);
            $("#add-company-benefit").modal("hide");
          }
        });
      }else{
      //   benefitamn: false,
      // benefitNam : false
      if(!this.benefitName){
        this.benefitNam = true;
      }else{
        this.benefitNam = false;
      }
      if(!this.BenefitAmount){
        this.benefitamn = true;
      }else{
        this.benefitamn = false;
      }
      }
    },
    clearNameAmount() {
      this.benefitName = "";
      this.BenefitAmount = "";
    },
    UpdateBenefit() {
      this.$axios({
        method: "POST",
        data: {
          name: this.benefitName,
          amount: this.BenefitAmount,
          id: this.benefitId,
        },
        url: this.$UpdateCompanyBenefit,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.$store.commit("setUser", res.data.result);
          $root.$toast.success(res.data.message);
          $("#benefit-name-" + this.benefitId).text(this.benefitName);
          $("#benefit-amount-" + this.benefitId).text(this.BenefitAmount);
          $("#benefit-modal").modal("hide");
        }
      });
    },
    openBenefitModal(id) {
      if (this.companyBenefits.length === 0) {
        let benefit = this.companyBenefits2.filter((item) => item.id === id)[0];
        this.benefitName = benefit.name;
        this.BenefitAmount = benefit.amount;
        this.benefitId = benefit.id;
      } else {
        let benefit = this.companyBenefits.filter((item) => item.id === id)[0];
        this.benefitName = benefit.name;
        this.BenefitAmount = benefit.amount;
        this.benefitId = benefit.id;
      }
    },
    deleteTag(removedOption) {
      if (confirm("Are you sure you want to delete this job type?")) {
        this.$axios({
          method: "POST",
          data: { name: removedOption, company_id: this.company_id },
          url: this.$DeleteTag,
          headers: this.getAuthHeader(),
        }).then((res) => {
          if (res.data.status == 200) {
            this.$store.commit("setUser", res.data.result);
            $root.$toast.success(res.data.message);
            this.uniqueKey++;
            this.getJobRolesList();

          } else if (res.data.status == 403) {
            this.getlist = this.getlist2;
            $root.$toast.error(res.data.message);
          }
        });
      } else {
        this.getCompany();
      }
    },
    addTag(newTag) {
      this.getlist.push({ name: newTag });
      this.submitCompanyJobRole(newTag);
    },
    onSelect(selectedItems) {
      this.submitCompanyJobRole(selectedItems.name);
    },
    submitCompanyJobRole(name) {
      this.$axios
        .post(
          this.$UpdateCompanyJobRoles,
          { company_id: this.company_id, job_role: name },
          {
            headers: this.getAuthHeader(),
          }
        )
        .then((response) => {
          if (response.status == 200) {
             $root.$toast.success(response.data.message);
            this.$store.commit("setUser", response.data.result);
            this.uniqueKey++;
           // console.log(response.data.result,'result');
            // this.$router.go(0);
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_data_ready = true;
        });
    },

    getJobRolesList() {
      let params = { list_type: ["job_roles"] };
      this.$axios({
        method: "get",
        params: params,
        url: this.$Getlistdata,
      })
        .then((response) => {
          this.options = response.data.result.job_roles;
        })
        .catch((error) => {
          console.log(error);
          this.is_data_ready = true;
        });
    },
    getCompany() {
      this.is_data_ready = false;
      this.id = this.company_id;
      this.$axios.get(this.$GetCompany.replace(":id", this.id), {
        headers: this.getAuthHeader(),
      }).then((response) => {
        $('#profile-employee').modal('hide');
          this.value            = response.data.result.company;
          this.form.jobRoles    = response.data.result.jobs;
          this.form.name        = this.value.name;
          this.form.company_id  = this.value.id;
          this.form.cvr         = this.value.cvr;
          this.form.postcode    = this.value.postcode;
          this.form.address     = this.value.address;
          this.form.country     = this.value.country;
          this.form.currency_id = this.value.currency_id;
          this.form.email       = this.value.user.email;
          this.form.phone       = this.value.user.phone;
          this.currencyName     = this.$store.getters.getSelectedCompany.currency.code;
          if (this.counter === 0) {
            this.getlist = [];
            this.form.jobRoles.forEach((element) => {
              this.getlist.push({ name: element.name }); // for show above
              this.jobRoleUniq.push(element.name);
            });
            this.getlist2     = this.getlist;
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_data_ready = true;
        });
    },
    saveCompanyLogo() {
      // console.log(this.$refs.companylogo.files[0]);
      this.$axios({
        method: "POST",
        data: {
          logo: this.$refs.companylogo.files[0],
          company_id: this.company_id,
        },
        url: this.$UpdateCompnayLogo,
        headers: this.getImageHeader(),
      }).then((res) => {});
    },
    //------------ update profile
    Update() {
      if(this.validate()){
        // this.$axios.patch(this.$UpdateCompany.replace(":id", this.company_id), this.form, {
        this.$axios.patch(this.$UpdateCompany.replace(":id", this.company_id), {
          address:this.form.address,
          company_id:this.form.company_id,
          country:this.form.country,
          currency_id:this.form.currency_id,
          cvr:this.form.cvr,
          email:this.form.email,
          industry_id:this.form.industry_id,
          latitude:this.form.latitude,
          longitude:this.form.longitude,
          name:this.form.name,
          phone:this.form.phone,
          postcode:this.form.postcode,
          requestFrom:this.form.requestFrom,
        }, {
            headers: this.getAuthHeader(),
          })
          .then((response) => {
            if (response.status == 200) {
              $("#profile-employee").modal("hide");
              this.counter++;
              this.$store.commit("setUser", response.data.result.user);
              $root.$toast.success(response.data.message);
              this.getCompany();
            }
          })
          .catch((error) => {
            console.log(error);
            this.is_data_ready = true;
          });
      }
    },
  },
};
</script>
<style scoped>
.textRed{
  color: red;
}
</style>
